import Error24 from '@carbon/icons-react/es/error/24';
import Warning24 from '@carbon/icons-react/es/warning/24';
import { ModalFuncProps } from 'antd/es/modal';
import merge from 'lodash/merge';
import React from 'react';
import { defaultModalProps, Modal } from './modal';
import styles from './modal.module.css';

const defaultMethodProps: ModalFuncProps = {
  className: styles.modal_method,
  icon: <Warning24 />,
  zIndex: Number(styles.zIndex),
};

const defaultErrorModalProps: ModalFuncProps = {
  className: styles.modal_method,
  icon: <Error24 />,
  zIndex: Number(styles.zIndex),
};

export const confirm = (props: ModalFuncProps = {}) => {
  const modalProps: ModalFuncProps = {
    ...props,
    okText: (
      <span data-cy={`modal.confirm.${props.okText || 'Ok'}`}>
        {props.okText || 'Ok'}
      </span>
    ),
    cancelText: (
      <span data-cy={`modal.cancel.${props.cancelText || 'Cancel'}`}>
        {props.cancelText || 'Cancel'}
      </span>
    ),
  };

  return Modal.confirm(
    merge({}, defaultModalProps, defaultMethodProps, modalProps),
  );
};

export const error = (props: ModalFuncProps = {}) =>
  Modal.error(merge({}, defaultModalProps, defaultErrorModalProps, props));
